/**
 * NANG LUC THAO TAC TRANG cua mot loi cu the.
 *
 * Hop dong kieu dung chung (packages/types) chi biet den EditCommand: no khong
 * co cho de "ghi nhan mot tep NGOAI de ghep vao", vi day la viec cua tang ung
 * dung chu khong phai cua dinh dang PDF. Thay vi noi rong hop dong, ta tham do
 * nang luc y het cach asPageSource() lam voi doi tuong trang cua pdf.js.
 *
 * Loi nao khong co nhung ham nay thi giao dien tu tat cac nut lien quan, thay
 * vi bam vao roi that bai.
 */
import type { DocumentId, DocumentInfo, PdfCore, Result } from '@pdfeditor/types';
import type { PagePlan } from './plan';

export interface RegisteredSource {
  docId: string;
  label: string;
  pageCount: number;
}

export interface PageOpsCapableCore {
  /** So do trang dang co hieu luc trong loi - de doi chieu voi thanh ben. */
  pagePlan(doc: DocumentId): Promise<Result<PagePlan>>;
  /** Kiem tra va ghi nhan byte cua mot tep ngoai truoc khi ghep. */
  registerSourceDocument(bytes: Uint8Array, label: string): Promise<Result<RegisteredSource>>;
  sourceLabel(docId: string): string | null;
}

/**
 * MO MOT TAI LIEU NGUON DE HIEN THI.
 *
 * Ghep tep xong thi so do trang chua nhung o tro sang mot tai lieu KHAC. Khung
 * xem phai ve duoc chung, va ve duoc nghia la phai co doi tuong tai lieu pdf.js
 * cua chinh tai lieu do - khong co cach nao lay trang cua tep B tu tai lieu cua
 * tep A.
 *
 * Tach thanh mot nang luc RIENG (khong gop vao PageOpsCapableCore) vi mot loi
 * co the ghep tep duoc ma khong cho muon doi tuong trang cua pdf.js: ban WASM
 * cua loi Rust chinh la truong hop do. Khi den luc, ham nay tra ve null va tang
 * hien thi tu lui ve o giu cho co nhan, chu khong vo va cung khong ve nham
 * trang cua tai lieu khac.
 */
export interface SourceViewCapableCore {
  /**
   * Mo (hoac lay lai ban da mo) mot tai lieu nguon da ghi nhan, de HIEN THI.
   * Goi nhieu lan voi cung `docId` tra ve cung mot tai lieu - khong mo lai, vi
   * moi lan mo la mot worker pdf.js nua.
   */
  openSourceForView(docId: string): Promise<Result<{ doc: DocumentId; info: DocumentInfo }>>;
  /** Dong toan bo tai lieu nguon dang mo de hien thi. Goi khi doi tep. */
  closeSourceViews(): Promise<void>;
}

export function asSourceViewCore(core: PdfCore | null): SourceViewCapableCore | null {
  if (!core) return null;
  const candidate = core as unknown as Partial<SourceViewCapableCore>;
  return typeof candidate.openSourceForView === 'function' &&
    typeof candidate.closeSourceViews === 'function'
    ? (candidate as SourceViewCapableCore)
    : null;
}

export function asPageOpsCore(core: PdfCore | null): PageOpsCapableCore | null {
  if (!core) return null;
  const candidate = core as unknown as Partial<PageOpsCapableCore>;
  return typeof candidate.registerSourceDocument === 'function' &&
    typeof candidate.pagePlan === 'function' &&
    typeof candidate.sourceLabel === 'function'
    ? (candidate as PageOpsCapableCore)
    : null;
}
